import Form from 'react-bootstrap/Form';
import './InstalationForm.scss'
import { useTranslation } from 'react-i18next';
import MapComponent, { IPosPoint } from '../../MapComponent/Map.component';
import { Instalation } from '../../../utils/models/Instalation';

const InstalationForm = (props: {
    formLock: boolean, edit: boolean; containerAux: Instalation, sendChange: (event: any) => void, onChangePos: (p: IPosPoint) => void
}) => {

    const { t } = useTranslation();
    const { containerAux } = props


    const onInputChange = (event: any) => {
        props.sendChange(event)
    };

    const onChangePos = (pos: IPosPoint) => {
        props.onChangePos(pos)
    }


    return (
        <div className="p-3 rounded-1" id='formInstalationContainer'>
            <Form>
                <div className="row mb-3 mt-2">
                    <div className="col">
                        <Form.Check disabled={props.formLock} name="active" type="checkbox" label={t('Active')} defaultChecked={containerAux.active} onClick={onInputChange} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{`${t('Name')}*`}</Form.Label>
                        <Form.Control disabled={props.formLock} name="name" type="text" className="inputStyle" onChange={onInputChange} value={containerAux.name} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Address')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="address" type="text" className="inputStyle" onChange={onInputChange} value={containerAux.address} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('City')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="city" type="text" className="inputStyle" onChange={onInputChange} value={containerAux.city} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg-8">
                        <div className='mapCont'>
                            <MapComponent showAllContainers={false} allContainers={[]} position={{ lat: containerAux.lat, lng: containerAux.lng }} setPosition={onChangePos} enable={props.formLock} />
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Lat')}</Form.Label>
                        <Form.Control disabled={true} name="lat" type="text" className="inputStyle" value={containerAux.lat} />
                        <Form.Label className='mb-0'>{t('Lng')}</Form.Label>
                        <Form.Control disabled={true} name="log" type="text" className="inputStyle" value={containerAux.lng} />
                    </div>
                </div>
            </Form>
        </div>
    )
}
export default InstalationForm;